import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://siki.io";
const DEFAULT_TITLE = "SIKI — Stream Music & Earn Real-Time Royalties | Music Platform for Artists";
const DEFAULT_DESCRIPTION =
  "Upload music, go live, and earn real-time royalties from every stream. SIKI is a creator-first music platform where artists and playlistors get paid — instantly, not months later.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

function SEO({ title, description, path, image, type = "website", noIndex = false }) {
  const fullTitle = title ? `${title} | SIKI` : DEFAULT_TITLE;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = path ? `${SITE_URL}${path}` : SITE_URL;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}

export default SEO;
